// Mock data for Shre Hingulmabika Educational Society - D.Ed College

export const collegeInfo = {
  name: "Shre Hingulmabika Educational Society",
  shortName: "SHES D.Ed College",
  tagline: "Nurturing Educators, Building Nations",
  established: "2008",
  affiliations: [
    "Approved by N.C.T.E",
    "Recognized by Govt. of Karnataka",
    "Affiliated to D.S.E.R.T. Bangalore",
  ],
  address: "Main Road, Educational District, Karnataka - 585101",
  phone: "+91 98765 43210",
  email: "info@shrehingulmabika.edu.in",
  hours: "Mon - Sat: 9:00 AM - 5:00 PM",
  social: {
    facebook: "#",
    instagram: "#",
    twitter: "#",
    youtube: "#",
  },
};

export const heroSlides = [
  {
    id: 1,
    title: "Shaping Tomorrow's Teachers Today",
    subtitle: "A legacy of excellence in teacher education since 2008",
    image: "https://images.unsplash.com/photo-1687709348710-05314eea5476",
    cta: "Explore Programs",
  },
  {
    id: 2,
    title: "Where Passion Meets Pedagogy",
    subtitle: "Empowering future educators with knowledge, skill, and character",
    image: "https://images.unsplash.com/photo-1680084521816-cc1ad0433ceb",
    cta: "Apply Now",
  },
  {
    id: 3,
    title: "Excellence in Teacher Training",
    subtitle: "Comprehensive D.Ed programs with hands-on experience",
    image: "https://images.unsplash.com/photo-1695204651916-a300caba0d7e",
    cta: "Learn More",
  },
];

export const highlights = [
  { icon: "Award", stat: "100%", label: "University Results" },
  { icon: "Users", stat: "1500+", label: "Alumni Network" },
  { icon: "BookOpen", stat: "25+", label: "Expert Faculty" },
  { icon: "GraduationCap", stat: "16", label: "Years of Legacy" },
];

export const features = [
  {
    icon: "Trophy",
    title: "100% Pass Results",
    desc: "Consistent excellence in university examinations year after year.",
  },
  {
    icon: "BookMarked",
    title: "Quality Teacher Education",
    desc: "Well-designed curriculum aligned with modern educational needs.",
  },
  {
    icon: "UserCheck",
    title: "Experienced Faculty",
    desc: "Qualified, dedicated teachers with decades of combined experience.",
  },
  {
    icon: "Briefcase",
    title: "Best Placement Support",
    desc: "Strong placement records in Government and Private sector schools.",
  },
];

export const courses = [
  {
    id: 1,
    code: "D.El.Ed",
    title: "Diploma in Elementary Education",
    duration: "2 Years",
    seats: 50,
    eligibility: "10+2 (Any Stream) with 50% marks",
    fee: "Contact Office",
    desc: "A comprehensive 2-year program preparing teachers for primary and upper-primary level classrooms with modern pedagogy.",
    highlights: [
      "NCTE Approved Curriculum",
      "School Internship Programs",
      "Child Psychology & Development",
      "Educational Technology Training",
    ],
  },
  {
    id: 2,
    code: "D.P.S.E",
    title: "Diploma in Pre-School Education",
    duration: "1 Year",
    seats: 30,
    eligibility: "10+2 (Any Stream) with 45% marks",
    fee: "Contact Office",
    desc: "Specialized program for early childhood educators with practical training in playschools and preschools.",
    highlights: [
      "Early Childhood Care",
      "Creative Curriculum Design",
      "Practical Playschool Training",
      "Montessori Method Training",
    ],
  },
  {
    id: 3,
    code: "CERT",
    title: "Certificate in Educational Leadership",
    duration: "6 Months",
    seats: 40,
    eligibility: "Graduate in any Discipline",
    fee: "Contact Office",
    desc: "A short program for aspiring school leaders, administrators, and curriculum designers.",
    highlights: [
      "Leadership Skills",
      "School Administration",
      "Policy Understanding",
      "Weekend Classes",
    ],
  },
];

export const facilities = [
  {
    icon: "Library",
    title: "Digital Library",
    desc: "Over 8,000 books, journals, and digital resources on education and pedagogy.",
    image: "https://images.unsplash.com/photo-1501503069356-3c6b82a17d89",
  },
  {
    icon: "Monitor",
    title: "Computer Lab",
    desc: "Modern computer lab with high-speed internet and educational software.",
    image: "https://images.unsplash.com/photo-1521587760476-6c12a4b040da",
  },
  {
    icon: "School",
    title: "Smart Classrooms",
    desc: "Interactive digital classrooms with projectors and modern teaching aids.",
    image: "https://images.unsplash.com/photo-1509062522246-3755977927d7",
  },
  {
    icon: "FlaskConical",
    title: "Science & Craft Lab",
    desc: "Hands-on laboratories for teaching science and craft methodologies.",
    image: "https://images.unsplash.com/photo-1577896851231-70ef18881754",
  },
  {
    icon: "Trophy",
    title: "Sports Ground",
    desc: "Spacious grounds for physical education, yoga and outdoor activities.",
    image: "https://images.unsplash.com/photo-1692269725911-87697c558be1",
  },
  {
    icon: "Bus",
    title: "Transportation",
    desc: "Safe and reliable transport service covering all major routes.",
    image: "https://images.unsplash.com/photo-1686624386665-4cd01b96d0f6",
  },
];

export const faculty = [
  {
    id: 1,
    name: "Dr. Prakash M. Deshpande",
    role: "Principal",
    qualification: "Ph.D. in Education, M.Ed, M.A",
    experience: "28 years",
    subject: "Educational Philosophy",
    image: "https://ui-avatars.com/api/?name=Prakash+Deshpande&background=1B5E3F&color=D4AF37&size=256",
  },
  {
    id: 2,
    name: "Prof. Anitha S. Kulkarni",
    role: "Vice Principal",
    qualification: "M.Ed, M.A (English)",
    experience: "22 years",
    subject: "English Pedagogy",
    image: "https://ui-avatars.com/api/?name=Anitha+Kulkarni&background=1B5E3F&color=D4AF37&size=256",
  },
  {
    id: 3,
    name: "Mr. Ravi B. Patil",
    role: "Senior Lecturer",
    qualification: "M.Ed, M.Sc (Math)",
    experience: "18 years",
    subject: "Mathematics Education",
    image: "https://ui-avatars.com/api/?name=Ravi+Patil&background=1B5E3F&color=D4AF37&size=256",
  },
  {
    id: 4,
    name: "Mrs. Sunita R. Joshi",
    role: "Lecturer",
    qualification: "M.Ed, M.A (Kannada)",
    experience: "15 years",
    subject: "Kannada & Regional Studies",
    image: "https://ui-avatars.com/api/?name=Sunita+Joshi&background=1B5E3F&color=D4AF37&size=256",
  },
  {
    id: 5,
    name: "Mr. Vinod K. Shetty",
    role: "Lecturer",
    qualification: "M.Ed, M.Sc (Physics)",
    experience: "12 years",
    subject: "Science Methodology",
    image: "https://ui-avatars.com/api/?name=Vinod+Shetty&background=1B5E3F&color=D4AF37&size=256",
  },
  {
    id: 6,
    name: "Dr. Meera V. Rao",
    role: "Senior Lecturer",
    qualification: "Ph.D. in Psychology, M.Ed",
    experience: "20 years",
    subject: "Child Psychology",
    image: "https://ui-avatars.com/api/?name=Meera+Rao&background=1B5E3F&color=D4AF37&size=256",
  },
];

export const gallery = [
  { id: 1, category: "Campus", image: "https://images.unsplash.com/photo-1687709348710-05314eea5476", title: "Main Campus Building" },
  { id: 2, category: "Classrooms", image: "https://images.unsplash.com/photo-1509062522246-3755977927d7", title: "Interactive Classroom" },
  { id: 3, category: "Library", image: "https://images.unsplash.com/photo-1501503069356-3c6b82a17d89", title: "Reading Hall" },
  { id: 4, category: "Events", image: "https://images.unsplash.com/photo-1607013407627-6ee814329547", title: "Annual Day Celebration" },
  { id: 5, category: "Events", image: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f", title: "Graduation Ceremony" },
  { id: 6, category: "Classrooms", image: "https://images.unsplash.com/photo-1577896851231-70ef18881754", title: "Science Lab Session" },
  { id: 7, category: "Campus", image: "https://images.unsplash.com/photo-1680084521816-cc1ad0433ceb", title: "Student Activities" },
  { id: 8, category: "Library", image: "https://images.unsplash.com/photo-1521587760476-6c12a4b040da", title: "Computer Lab" },
  { id: 9, category: "Events", image: "https://images.unsplash.com/photo-1692269725911-87697c558be1", title: "Sports Day" },
  { id: 10, category: "Campus", image: "https://images.unsplash.com/photo-1695204651916-a300caba0d7e", title: "Student Life" },
  { id: 11, category: "Classrooms", image: "https://images.pexels.com/photos/9159059/pexels-photo-9159059.jpeg", title: "Group Study" },
  { id: 12, category: "Events", image: "https://images.unsplash.com/photo-1686624386665-4cd01b96d0f6", title: "Cultural Program" },
];

export const boardMembers = {
  president: {
    name: "Suresh Bulbule",
    role: "President",
    image: "https://shes-ayurvedicmedicalcollege.com/wp-content/uploads/2022/08/01-150x150-1-150x150-1.jpg",
  },
  executives: [
    {
      name: "Sri Vijaykumar Tukaram",
      role: "Vice President",
      image: "https://shes-ayurvedicmedicalcollege.com/wp-content/uploads/2022/08/02-150x150-1-150x150-1.jpg",
    },
    {
      name: "Sri Naresh S. Tandle",
      role: "Secretary",
      image: "https://shes-ayurvedicmedicalcollege.com/wp-content/uploads/2022/08/03-150x150-1-150x150-1.jpg",
    },
    {
      name: "Sri Santosh D. Ghanate",
      role: "Joint Secretary",
      image: "https://shes-ayurvedicmedicalcollege.com/wp-content/uploads/2022/08/04-150x150-1-150x150-1.jpg",
    },
    {
      name: "Sri Tulasidas N. Astikar",
      role: "Treasurer",
      image: "https://shes-ayurvedicmedicalcollege.com/wp-content/uploads/2022/08/05-150x150-3-150x150-1.jpg",
    },
  ],
  members: [
    {
      name: "Sri Ramesh K. Astikar",
      image: "https://shes-ayurvedicmedicalcollege.com/wp-content/uploads/2022/08/06-150x150-1-150x150-1.jpg",
    },
    {
      name: "Sri Bhushan R. Tandle",
      image: "https://shes-ayurvedicmedicalcollege.com/wp-content/uploads/2022/08/07-150x150-2-150x150-1-150x150.jpg",
    },
    {
      name: "Sri Prakash G. Hibare",
      image: "https://shes-ayurvedicmedicalcollege.com/wp-content/uploads/2022/08/08-150x150-3-150x150-1.jpg",
    },
    {
      name: "Sri Suresh M. Rangdal",
      image: "https://shes-ayurvedicmedicalcollege.com/wp-content/uploads/2022/08/09-150x150-1-150x150-1.jpg",
    },
    {
      name: "Sri Dattatraya P. Pukale",
      image: "https://shes-ayurvedicmedicalcollege.com/wp-content/uploads/2022/08/10-150x150-1-150x150-1.jpg",
    },
    {
      name: "Sri Balkishan V. Kshirasagar",
      image: "https://shes-ayurvedicmedicalcollege.com/wp-content/uploads/2022/08/13-150x150-1-150x150-1.jpg",
    },
    {
      name: "Sri Sushant S. Hanchate",
      image: "https://shes-ayurvedicmedicalcollege.com/wp-content/uploads/2022/08/14-150x150-1-150x150-1.jpg",
    },
    {
      name: "Sri Sushil S. Bulbule",
      image: "https://shes-ayurvedicmedicalcollege.com/wp-content/uploads/2025/03/Technology-e1740851664566.jpg",
    },
    {
      name: "Sri Vinod V. Astikar",
      image: "https://shes-ayurvedicmedicalcollege.com/wp-content/uploads/2025/03/Technology-1.jpg",
    },
    {
      name: "Sri Sridatta S. Bulbule",
      image: "https://shes-ayurvedicmedicalcollege.com/wp-content/uploads/2025/03/Technology-2-e1740851890841.jpg",
    },
  ].map((m) => ({ ...m, role: "Member" })),
};

export const testimonials = [
  {
    id: 1,
    name: "Priya Nayak",
    batch: "D.El.Ed 2022",
    role: "Primary School Teacher, Bangalore",
    quote:
      "The faculty here shaped me not just as a teacher but as a lifelong learner. The internship exposure was invaluable in preparing me for real classrooms.",
    avatar: "https://ui-avatars.com/api/?name=Priya+Nayak&background=D4AF37&color=1B5E3F&size=200",
  },
  {
    id: 2,
    name: "Kiran Kumar",
    batch: "D.El.Ed 2021",
    role: "Govt. School Teacher, Karnataka",
    quote:
      "From child psychology to modern pedagogy, everything I learned here I use every single day. Grateful for the mentors and the environment.",
    avatar: "https://ui-avatars.com/api/?name=Kiran+Kumar&background=D4AF37&color=1B5E3F&size=200",
  },
  {
    id: 3,
    name: "Sneha Deshmukh",
    batch: "D.P.S.E 2023",
    role: "Pre-School Coordinator",
    quote:
      "The blend of theory and practical exposure is what sets this college apart. The Montessori training changed how I look at early education.",
    avatar: "https://ui-avatars.com/api/?name=Sneha+Deshmukh&background=D4AF37&color=1B5E3F&size=200",
  },
];

export const news = [
  {
    id: 1,
    date: "2025-06-15",
    category: "Admissions",
    title: "D.El.Ed 2025-27 Admissions Open",
    excerpt:
      "Applications are now open for the two-year D.El.Ed programme for the 2025-27 batch. Limited seats available.",
  },
  {
    id: 2,
    date: "2025-05-22",
    category: "Achievement",
    title: "100% Results in 2024-25 University Exams",
    excerpt:
      "Congratulations to our graduating batch for achieving 100% pass results with several distinctions.",
  },
  {
    id: 3,
    date: "2025-04-10",
    category: "Event",
    title: "Annual Teachers' Day Symposium",
    excerpt:
      "A day-long symposium on 'Future of Teacher Education in India' with distinguished speakers.",
  },
  {
    id: 4,
    date: "2025-03-05",
    category: "Workshop",
    title: "Workshop on Modern Pedagogical Tools",
    excerpt:
      "A 3-day workshop conducted on integrating technology into everyday classroom teaching.",
  },
];

export const faqs = [
  {
    q: "What is the duration of the D.El.Ed program?",
    a: "The D.El.Ed (Diploma in Elementary Education) is a 2-year full-time program divided into 4 semesters, including school internship.",
  },
  {
    q: "What is the eligibility for admission?",
    a: "Candidates must have passed 10+2 (any stream) with a minimum of 50% marks from a recognized board. Reserved categories get relaxation as per Government norms.",
  },
  {
    q: "Is the college NCTE approved?",
    a: "Yes, our college is approved by NCTE (National Council for Teacher Education), recognized by Govt. of Karnataka, and affiliated to D.S.E.R.T. Bangalore.",
  },
  {
    q: "Do you provide hostel facilities?",
    a: "We have tie-ups with nearby hostels for both boys and girls. Please contact the admissions office for details on accommodation.",
  },
  {
    q: "What placement opportunities are available?",
    a: "Our graduates work across Government schools, private schools, playschools, and international curriculum schools. We offer dedicated placement support.",
  },
  {
    q: "When does the admission process start?",
    a: "Admissions typically open in May and continue till August each year, subject to seat availability. Early application is encouraged.",
  },
];
